import {
	Button,
	Link,
	VStack,
	FormControl,
	Text,
	useBreakpointValue,
	Input,
	Flex,
	FormErrorMessage,
	Box,
} from "@chakra-ui/react";
import { Formik, Field, Form } from "formik";
import * as Yup from 'yup';
import { chakra } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import RecentChecksBadgesList from "./RecentChecksBadgesList";

const ethereumAddressRegex = /^0x[a-fA-F0-9]{40}$/;

const validationSchema = Yup.object().shape({
	address: Yup.string()
		.required('Address is required')
		.min(1, 'Address cannot be empty')
		.max(1000, 'Address must be at most 1000 characters')
		.matches(ethereumAddressRegex, 'Invalid Ethereum address'),
});


const CheckBadgeRankForm = ({ handleSubmit, serverError, isUserHasKey, isKeyMintAvailiable, recentChecks, handleClearRecentChecks }) => {
	const isMobile = useBreakpointValue({ base: true, md: false });

	return (
		<Formik
			initialValues={{ address: '' }}
			validationSchema={validationSchema}
			onSubmit={handleSubmit}
			validateOnChange={false}
			validateOnBlur={false}
		>
			{({ isSubmitting, errors, touched, values, setFieldValue }) => (
				<Form>
					<Flex justifyContent={'center'}>
						<VStack spacing={4} align="stretch" w={isMobile ? '100%' : "700px"} alignContent={"center"}>
							<FormControl display="flex" alignItems="center" justifyContent="center">

								<Field name="address">
									{({ field, }) => (
										<FormControl isInvalid={errors.address && touched.address}>
											<Field
												as={Input}
												fontSize={!isMobile ? "1.25rem" : '0.8rem'}
												id={"address"}
												name={"address"}
												placeholder={"Enter your wallet..."}
												height={isMobile ? '35px' : '60px'}
												minWidth={isMobile ? 'auto' : '700px'}
												width="100%"
												border="1px solid rgb(255, 104, 75)"
												outline="1px solid rgb(255, 104, 75)"
												textAlign="center"
												_focus={{
													borderColor: "rgb(255, 104, 75)",
													outline: "1px solid rgb(255, 104, 75)"
												}}
												sx={{
													'::placeholder': {
														fontSize: !isMobile ? "1.2rem" : '0.8rem',
														color: 'gray.400',
													}
												}}
											/>

											<FormErrorMessage>{errors.address}</FormErrorMessage>
											{!errors.address && <Box color={"red.500"} mt={2} fontSize={"sm"}>{serverError}</Box>}
										</FormControl>
									)}
								</Field>
							</FormControl>
							<Button
								type="submit"
								isLoading={isSubmitting}
								background="#FF684B"
								color="white"
								_hover={{ background: "#FF5733" }}
								height={!isMobile ? "58px" : "35px"}
								isDisabled={!values.address && !values.addresses}
								size={!isMobile ? 'lg' : 'xs'}
							>
								GET RANK
							</Button>

							<Text align="center">
								Any question?{' '}
								<Link as={RouterLink} to="/faq">
									<chakra.span color="#FF5733" _hover={{ textDecoration: "underline" }}>
										Read FAQ
									</chakra.span>
								</Link>
							</Text>
						</VStack>
					</Flex>
					<RecentChecksBadgesList
						recentChecks={recentChecks}
						onSelectAddress={(address) => setFieldValue('address', address)}
						onClear={handleClearRecentChecks}
					/>
				</Form>
			)}
		</Formik>
	);
};

export default CheckBadgeRankForm;
